<script>
    import { Link } from "svelte-routing";
    import { datasetStore } from '../stores/dataset';
    import { base } from '../utils/base';
    // Subscribe to the store
    $: cards = $datasetStore;

    // Add statistics data
    const stats = [
        { number: "8+", label: "Member Countries" },
        { number: "50+", label: "Datasets" },
        { number: "100+", label: "Map Layers" },
        { number: "1000+", label: "Data Points" }
    ];
</script>

<!-- Background Image Section (Enhanced) -->
<div class="relative">
    <div class="absolute inset-0 bg-black/40 z-10"></div>
    <img 
        src="{base}/images/image_4.png" 
        alt="Regional Data Explorer" 
        class="w-full h-[50vh] object-cover"
    />
    <div class="absolute z-20 bottom-8 left-8 max-w-2xl">
        <h2 class="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
            Regional Data Explorer
        </h2>
        <p class="text-white/90 mt-4 text-lg">
            Explore comprehensive data across the Hindu Kush Himalaya region
        </p>
        <!-- <Link to="/datasets">
            <button class="mt-6 px-6 py-3 bg-grey-6 hover:bg-blue-700 text-white rounded-lg 
                          transition-all duration-300 transform hover:scale-105">
                Start Exploring
            </button>
        </Link> -->
    </div>
</div>

<!-- Member Country Flags Section -->
<div class="w-full px-4 flex justify-end  py-2 pr-0">
    <div class="flex space-x-3 md:space-x-2">
        {#each ['afghanistan', 'bangladesh', 'bhutan', 'china', 'india', 'myanmar', 'nepal', 'pakistan'] as country}
            <div class="flex flex-col items-center group">
                <img 
                    src="{base}/images/flags/{country}.png" 
                    alt={country} 
                    class="h-2 md:h-4 lg:h-4 w-auto transform transition-all duration-300 
                    "
                />
                <!-- <span class="text-xs mt-1 text-gray-600 capitalize">{country}</span> -->
            </div>
        {/each}
    </div>
</div>

<!-- Statistics Section (New) -->
<!-- <div class="bg-gray-50 py-12">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="grid grid-cols-2 md:grid-cols-4 gap-8">
            {#each stats as stat}
                <div class="text-center">
                    <div class="text-4xl font-bold text-blue-600">{stat.number}</div>
                    <div class="text-gray-600 mt-2">{stat.label}</div>
                </div>
            {/each}
        </div>
    </div>
</div> -->

<!-- Cards Section -->
<div class="w-full px-4 sm:px-6 lg:px-8 py-10">
    <div class="grid md:grid-cols-2 gap-8 max-w-7xl mx-auto">
        <!-- Explore Datasets Card -->
        <div class="group bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-blue-100">
            <Link to="{base}/datasets"  class="block h-full">
                <div class="flex items-start space-x-4">
                    <div class="p-3 bg-blue-50 rounded-lg group-hover:bg-blue-100 transition-colors duration-300">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                    </div>
                    <div>
                        <h3 class="text-xl font-semibold text-gray-800 group-hover:text-blue-600 transition-colors duration-300">
                            Explore Datasets
                        </h3>
                        <p class="mt-2 text-gray-600 leading-relaxed">
                            Browse, analyze, and interact with a diverse range of datasets.
                        </p>
                    </div>
                </div>
            </Link>
        </div>

        <!-- Map Viewer Card -->
        <div class="group bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-green-100">
            <Link to="{base}/mapViewer" class="block h-full">
                <div class="flex items-start space-x-4">
                    <div class="p-3 bg-green-50 rounded-lg group-hover:bg-green-100 transition-colors duration-300">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                        </svg>
                    </div>
                    <div>
                        <h3 class="text-xl font-semibold text-gray-800 group-hover:text-green-600 transition-colors duration-300">
                            Map Viewer
                        </h3>
                        <p class="mt-2 text-gray-600 leading-relaxed">
                            Explore spatial insights and visualize data layers on interactive maps.
                        </p>
                    </div>
                </div>
            </Link>
        </div>
    </div>
</div>

<!-- Featured Datasets Section -->
<div class="py-16 bg-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 class="text-3xl font-bold text-gray-900 mb-8">Featured Datasets</h2>
        <div class="grid md:grid-cols-3 gap-6">
            {#each $datasetStore.slice(0, 3) as dataset}
                <div class="bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden">
                    <Link to="{base}/dataDetail?id={dataset.id}">
                        <div class="h-48 bg-gray-200">
                            <img 
                                src={dataset.thumbnail} 
                                alt={dataset.dataset}
                                class="w-full h-full object-cover cursor-pointer"
                            />
                        </div>
                    </Link>
                    <div class="p-6">
                        <h3 class="text-xl font-semibold mb-2">{dataset.dataset}</h3>
                        <p class="text-gray-600 mb-4">{dataset.description || dataset.paragraph.slice(0, 100)}...</p>
                    </div>
                </div>
            {/each}
        </div>
    </div>
</div>



<!-- About Section (New) -->
<div class="bg-gray-50 py-16">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="grid md:grid-cols-2 gap-12 items-center">
            <div>
                <h2 class="text-3xl font-bold text-gray-900 mb-6">About the Regional Data Explorer</h2>
                <p class="text-gray-600 mb-4 text-justify">
                    The Regional Data Explorer allows interactive visualization of data in the form of map and statistics. It provides links to dashboard applications that enable users to query and visualize data in intuitive manner. 
                </p>
                <!-- <Link to="/about">
                    <button class="px-6 py-3 bg-gray-800 hover:bg-gray-900 text-white rounded-lg 
                                 transition-all duration-300">
                        Learn More About Us
                    </button>
                </Link> -->
            </div>
            <div class="relative h-[400px]">
                <img 
                    src="{base}/images/image_4.png" 
                    alt="About Regional Data Explorer" 
                    class="rounded-lg shadow-xl object-cover w-full h-full"
                />
            </div>
        </div>
    </div>
</div>

<!-- Footer (New) -->
<footer class="bg-gray-800 text-white py-12">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="grid md:grid-cols-3 gap-8">
            <div>
                <h3 class="text-xl font-semibold mb-4">Regional Data Explorer</h3>
                <p class="text-gray-400">
                    Providing comprehensive data access across the Hindu Kush Himalaya region
                </p>
            </div>
            <div>
                <h3 class="text-xl font-semibold mb-4">Quick Links</h3>
                <ul class="space-y-2 text-white">
                    <li><Link to="/datasets" class="text-gray-400 hover:text-white">Datasets</Link></li>
                    <li><Link to="/mapViewer" class="text-gray-400 hover:text-white">Map Viewer</Link></li>
                    <!-- <li><Link to="/about" class="text-gray-400 hover:text-white">About</Link></li> -->
                </ul>
            </div>
            <div>
                <h3 class="text-xl font-semibold mb-4">Contact</h3>
                <p class="text-gray-400">
                    Email: info@icimod.org<br>
                    Phone: (977) 1-527-5222, 5275223
                </p>
            </div>
        </div>
        <div class="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            © {new Date().getFullYear()} Regional Data Explorer. All rights reserved.
        </div>
    </div>
</footer>